import { addProject, getCurrentProjects } from '@/services/projectsService'

import { clientAddTracksToProject } from '@/client'
import { create } from 'zustand'

interface ProjectState {
	projects: Project[]
	getProjects: () => void
	addProject: (name: string, description?: string) => Promise<Project>
	editProject: (project: Project) => void
	deleteProject: (id: string) => void
	duplicateProject: (project: Project) => void
	addTrackToProject: (projectId: string, trackId: number) => Promise<void>
}

const useProjectStore = create<ProjectState>()((set) => ({
	projects: null,
	getProjects: async () => {
		const projects = await getCurrentProjects(1, 100, 0, 0)

		set({ projects })
	},
	addProject: async (name, description) => {
		const project = await addProject(name, description)

		set((state) => ({
			projects: [project, ...(state.projects ?? [])],
		}))

		return project
	},
	editProject: (project) => {
		set((state) => ({
			projects: state.projects?.map((x) => (x.Id === project.Id ? project : x)),
		}))
	},
	deleteProject: (id) => {
		set((state) => ({
			projects: state.projects?.filter((project) => project.Id !== id),
		}))
	},
	duplicateProject: (project) => {
		set((state) => ({
			projects: [project, ...(state.projects ?? [])],
		}))
	},
	addTrackToProject: async (projectId, trackId) => {
		const tracks = await clientAddTracksToProject(projectId, [trackId])

		set((state) => ({
			projects: state.projects?.map((project) => {
				if (project.Id === projectId) {
					return {
						...project,
						Tracks: [...(project.Tracks || []), ...tracks],
					}
				}
				return project
			}),
		}))
	},
}))

export default useProjectStore
